import { get, isEmpty } from 'lodash-es'
import {
  LinkAnalysis,
  Platform,
} from '@/tests/mock-data/mock-content-distribution'
import { getMainPlatformsByPlatformType } from '@/utils/get-main-platforms'

const convertFetchKolLinkAnalysisResponseToLinkAnalysis = (
  platform: Platform,
): LinkAnalysis[] => {
  return getMainPlatformsByPlatformType(Object.keys(platform))
    .filter((platformKey) => {
      const _platformData = platform[platformKey]
      const threeMonths = get(_platformData, '3m', [])
      const sixMonths = get(_platformData, '6m', [])
      return !isEmpty(threeMonths) || !isEmpty(sixMonths)
    })
    .map((platformKey) => {
      return { platformKey, ...platform[platformKey] }
    })
}

export default convertFetchKolLinkAnalysisResponseToLinkAnalysis
